import { render, staticRenderFns } from "./OfferDetailsModal.vue?vue&type=template&id=b249aa20&scoped=true&"
import script from "./OfferDetailsModal.vue?vue&type=script&lang=js&"
export * from "./OfferDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./OfferDetailsModal.vue?vue&type=style&index=0&id=b249aa20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b249aa20",
  null
  
)

export default component.exports